import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";

autoload();

window.app = new Vue({
  el: "#vue-testing",
  mixins: [initDom, auth, cart],

  data() {
    return {
      bannerVideo: window._PR?.bannerVideo || false,
      outdoorCorrosion: window._PR?.outdoorCorrosion || false,
      outdoorCorrosionDoc: window._PR?.outdoorCorrosionDoc || false,
      saltChamberTest: window._PR?.saltChamberTest || false,
      abrasionTest: window._PR?.abrasionTest || false,
      abrasionTestDoc: window._PR?.abrasionTestDoc || false,
      highTempTestDoc: window._PR?.highTempTestDoc || false,
      chemicalResistanceDoc: window._PR?.chemicalResistanceDoc || false,
      nvCamo: window._PR?.nvCamo || false,
      nvCamoDoc: window._PR?.nvCamoDoc || false,
      hardnessDoc: window._PR?.hardnessDoc || false,
      adhesionDoc: window._PR?.adhesionDoc || false,
      colorMeasureDoc: window._PR?.colorMeasureDoc || false,
      durabilityDoc: window._PR?.durabilityDoc || false,
      techReportDoc: window._PR?.techReportDoc || false,
      saltChamberDoc: window._PR?.saltChamberDoc || false,
      photopolymersDoc: window._PR?.photopolymersDoc || false,
      multiJetDoc: window._PR?.multiJetDoc || false,
      playBanner: false,
      playOutdoorCorrosion: false,
      playSaltChamberTest: false,
      playAbrasionTest: false,
      playNvCamo: false,
    };
  },

  mounted() {
    $(window).on("resize load", function () {
      $(window).scroll(function () {
        if ($(window).scrollTop() >= 500) {
          $(".back-to-top").css("display", "inline");
        } else {
          $(".back-to-top").css("display", "none");
        }
      });
    });
  },
});
